import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonPagesModule } from '@homeleite/common-pages'
import { DefaultSharedModule } from '@homeleite/default-shared';
import { LayoutModule } from '../layout/layout.module';
/* import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
 */
const MODULES = [
  CommonPagesModule,
  DefaultSharedModule,
  LayoutModule,
];
/*
const material = [

] */
@NgModule({
  imports: [
    CommonModule, ...MODULES
  ],
  exports: MODULES
})
export class SharedModule { }
